import styled from "styled-components";

export const Container = styled.div`
  display: flex;

  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const Description = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.333em;
  letter-spacing: 1.67%;
  color: #333333;
  margin: 0;
  width: 100%;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

export const Label = styled.label`
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.286em;
  color: #6e707c;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f7f8fc;
  border: 1px solid #d4d8e1;
  border-radius: 4px;
`;

export const Input = styled.input`
  flex: 1;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5em;
  letter-spacing: 1.25%;
  color: #252733;
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: rgba(37, 39, 51, 0.4);
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #e7ecee;
`;

export const InvitedSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`;

export const InvitedTitle = styled.h3`
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.172em;
  letter-spacing: 6.25%;
  text-transform: uppercase;
  color: #333333;
  margin: 0;
  cursor: pointer;
  &:hover {
    color: #1b75bb;
    text-decoration: underline;
  }
`;

export const ChevronIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const TableSection = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  height: ${({ isExpanded }) => (isExpanded ? "auto" : "0")};
  transition: height 0.3s ease-in-out;
  overflow: hidden;
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-self: stretch;
  gap: 8px;
`;

export const TableHeaderItem = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.286em;
  color: #6e707c;

  &:first-child {
    flex: 1;
  }
`;

export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  padding: 16px;
  background: #f3f5fb;
  border: 1px solid #e7ecee;

  &:nth-child(odd) {
    background: white;
    border-top: none;
  }
  &:nth-child(2) {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-top: 8px;
  }
`;

export const TableRowEmail = styled.div`
  flex: 1;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5em;
  letter-spacing: 1.875%;
  color: #333333;
`;

export const TableRowStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const StatusText = styled.div`
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  letter-spacing: 1.875%;
  color: #333333;
`;

export const ChevronContainer = styled.div`
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 7px;
    height: 3.5px;
    stroke: #454f5b;
    stroke-width: 1.5px;
    transform: rotate(90deg);
  }
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  width: 368px;
  border: 1px dashed #94adc2;
  border-radius: 4px;
  box-sizing: border-box;
`;

export const EmptyStateText = styled.p`
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4em;
  text-align: center;
  color: #8c8d94;
  margin: 0;
`;

export const SendButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 11px 58px;
  background: #1b75bb;
  border: none;
  border-radius: 25px;
  box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.16);
  cursor: pointer;
  width: fit-content;

  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  letter-spacing: 1.25%;
  color: #ffffff;

  &:hover {
    background: #155a94;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  width: 163px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 0px rgba(51, 51, 51, 0.16);
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
`;

export const DropdownItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;

  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.714em;
  text-align: center;
  color: #eb636b;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ClickableChevronContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
